export const ACTION_RESET = 'FETCH_VIDEODATALISTBYIDS_RESET';
export const ACTION_REQUEST = 'FETCH_VIDEODATALISTBYIDS_REQUEST';
export const ACTION_SUCCESS = 'FETCH_VIDEODATALISTBYIDS_SUCCESS';
export const ACTION_ERROR = 'FETCH_VIDEODATALISTBYIDS_ERROR';
